<template>
  <div class="CitySelectCom-wrap">
    <el-popover
      popper-class="CitySelectCom-popover"
      placement="bottom-start"
      width="400"
      v-model="isShowPopover"
      :visible-arrow="false"
      trigger="focus"
    >
      <el-input
        style="width:111px"
        @input="inputContent"
        v-model="inputVal"
        clearable
        slot="reference"
        placeholder="请选择"
        :disabled="true"
      >
        <i slot="suffix" class="el-input__icon el-icon-arrow-down"></i>
      </el-input>
      <!-- <div class="showContent"    slot="reference">
        <span>{{inputVal}}</span>
      </div> -->
      <!--      直接进行选择的城市-->
      <div v-if="!isSearch" class="pd10">
        <div class="select-city-wrap">
          <div class="dis-fl pl10 ju-sb">
            <div class="fs12 cl666666">选择城市</div>
            <div>
              <i
                @click="isShowPopover = false"
                class="fs18 fb cl999999 cursor el-icon-close"
              ></i>
            </div>
          </div>
          <div class="tabs-wrap pl10">
            <el-tabs @tab-click="handleClick" v-model="activeName">
              <el-tab-pane
                v-for="(item, index) in newCityList"
                :key="index"
                :label="item.name"
                :name="item.name"
              >
              </el-tab-pane>
            </el-tabs>
          </div>
          <!--          热门城市-->
          <!--          <div v-if="activeName === '热门城市'" class="select-city-box dis-fl fw-w">-->
          <div class="select-city-box dis-fl fw-w">
            <div @click="clickItem(AllCity)" class="city-item cursor">
              全国
            </div>
            <div
              @click="clickItem(item)"
              class="city-item cursor"
              v-for="(item, index) in childCityList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <!--         字母城市-->
          <!--          <div v-else class="select-city-box dis-fl fw-w">-->
          <!--            <div class="city-item cursor" v-for="(item,index) in childCityList" :key="index">-->
          <!--              {{item.name}}-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              <div class="letter">{{index +1}}</div>-->
          <!--            </div>-->
          <!--            <div class="city-box dis-fl fw-w">-->
          <!--              <div v-for="(itmeIn, indexIn) in 5" :key="indexIn" class="city-item cursor">-->
          <!--                乌鲁木齐-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <!--      根据输入值搜索的城市-->
      <div v-else class="search-wrap">
        <div v-if="isNotData" class="fs14 cl666666 tc pd20">暂无匹配数据</div>
        <ul class="search-box">
          <li
            @click="clickSearchItem(item)"
            v-for="(item, index) in MatchList"
            :key="index"
            class="cursor fs12 cl666666 search-item"
          >
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { apiHome } from "@/api/zhaocai/apiHome"
export default {
  name: "CitySelectCom",
  model: {
    prop: "modelVal", // 指向props的参数名
    event: "change" // 事件名称
  },
  data() {
    return {
      // 全国数据
      AllCity: {
        name: "全国"
      },
      // 是否没有数据
      isNotData: false,
      // 是否是搜索
      isSearch: false,
      // 输入值
      inputVal: "",
      // 选中的类型
      activeName: "热门城市",
      // 是否显示菜单
      isShowPopover: false,
      // 子城市
      childCityList: [],
      // 所有数组
      allCityList: [],
      // 所有匹配的结果
      MatchList: [],
      timer: null,
      newCityList: []
    }
  },
  props: {
    modelVal: {
      type: String
    },
    IsAll: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    newCityList: {
      handler: function(nVal) {
        // if (this.$store.state.newCityList.length) {
        //   let arr = this.$store.state.newCityList.slice(1);
        //   arr.forEach((item, index) => {
        //     item.children.forEach((itemIn, indexIn) => {
        //       this.allCityList.push(itemIn);
        //     });
        //   });
        //   this.handleClick({ name: this.activeName });
        // }
        if (nVal.length) {
          let arr = nVal.slice(1)
          arr.forEach((item, index) => {
            item.children.forEach((itemIn, indexIn) => {
              this.allCityList.push(itemIn)
            })
          })
          this.handleClick({ name: this.activeName })
        }
      },
      immediate: true
    },
    modelVal: {
      handler(nVal) {
        this.inputVal = nVal
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getNewCityList()
    })
  },
  methods: {
    // 获取新的城市列表
    getNewCityList() {
      apiHome.getNewCityList().then(res => {
        if (res && res.status === 200) {
          this.newCityList = res.data
        }
      })
    },
    handleClick(tab, event) {
      let child = this.newCityList.find((item, index) => {
        return item.name === tab.name
      })
      this.childCityList = child.children
    },
    // 点击城市项
    clickItem(item) {
      this.inputVal = item.name
      if (this.IsAll) {
        this.$emit("change", item.name)
      } else {
        this.$emit("change", item.no)
      }

      this.isShowPopover = false
    },
    // 点击候选项
    clickSearchItem(item) {
      this.inputVal = item.name
      if (this.IsAll) {
        this.$emit("change", item.name)
      } else {
        this.$emit("change", item.no)
      }

      this.isShowPopover = false
    },
    // 输入框输入时
    inputContent() {
      if (!this.inputVal.length) {
        if (this.IsAll) {
          this.$emit("change", {})
        } else {
          this.$emit("change", "")
        }
        // this.$emit("change", "");
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.MatchList = []
        this.isSearch = Boolean(this.inputVal.length)
        let str = this.inputVal.toLocaleUpperCase()
        this.allCityList.forEach((item, index) => {
          if (item.searchKey.includes(str)) {
            this.MatchList.push(item)
          }
        })
        this.isNotData = !this.MatchList.length
      }, 300)
    }
  },
  mixins: [],
  filters: {},
  components: {}
}
</script>
<style lang="scss" scoped>
.TabCheck_Content {
  .el-input--suffix .el-input__inner {
    padding: 0 15px;
  }
  .is-disabled {
    background-color: white;
    border-color: white;
    color: #c0c4cc;
    :hover {
      cursor: pointer !important;
    }
  }
}
.showContent {
  width: 50px;
  height: 40px;
  border: 1px solid red;
}
.pd10 {
  padding: 10px;
}
.pl10 {
  padding-left: 10px;
}
.ju-sb {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.dis-fl {
  display: flex;
}
.fw-w {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.dis-fl {
  display: flex;
}
.cursor {
  cursor: pointer;
}
</style>
<!--修改外层弹出框的样式-->
<style lang="scss">
.CitySelectCom-popover {
  margin-top: -10px !important;
  border-radius: 0 !important;
  padding: 0 !important;

  .select-city-wrap {
    .tabs-wrap {
      margin-top: 5px;
    }

    .el-tabs__item {
      padding: 0 15px 0 0 !important;
      font-size: 12px !important;
      line-height: 28px;
      height: 28px;
    }

    .el-tabs__item:hover .el-tabs__item.is-active {
      color: #0286df !important;
    }

    .el-tabs__header {
      margin: 0 !important;
    }

    /*选择城市*/
    .select-city-box {
      padding-top: 10px;

      .city-item {
        width: 63px;
        text-align: center;
        padding: 6px 0;
        color: #333333;
        font-size: 12px;

        &:hover {
          background: #2e90fe;
          color: #ffffff;
        }
      }

      .letter-item {
        .letter {
          width: 30px;
          text-align: center;
          padding-top: 5px;
          color: #ff9900;
        }
      }
    }
  }

  .search-wrap {
    .search-item {
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      border-bottom: 1px solid rgba(228, 231, 237, 1);

      &:hover {
        background: #0286df;
        color: #ffffff;
      }
    }

    .search-box {
      max-height: 300px;
      overflow-y: auto;
    }
  }
}
</style>
